import { render } from "./btn-cell-renderer.vue?vue&type=template&id=4e97ed02"
import script from "./btn-cell-renderer.vue?vue&type=script&lang=js"
export * from "./btn-cell-renderer.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__